import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {OrderReadyDisplaySearchModel} from "../order-ready-display-search.model";
import {OrderReadyDisplayEntityModel} from "../order-ready-display-entity.model";

@Component({
    selector: "wbo-order-ready-display-search-page",
    templateUrl: "./order-ready-display-search-page.component.html",
    providers: [
        provideSearchModel(OrderReadyDisplaySearchModel),
        provideEntityModel(OrderReadyDisplayEntityModel)
    ]
})
export class OrderReadyDisplaySearchPageComponent extends AbstractSearchPage {
}
